import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import css from './BetaPill.module.css';

/**
 * "Beta" marker for "Proteger reserva externa".
 *
 * The feature is going out to a small group of hosts first, and this is what says so —
 * both to set expectations and to make it obvious that rough edges are expected.
 *
 * HOST-FACING ONLY. It is deliberately absent from `/reserva-externa/:token`: the
 * bañista is being asked to pay, and telling them the payment flow is in beta buys
 * nothing but hesitation. The host is the one who opted in.
 */
const BetaPill = props => <span className={classNames(css.pill, props.className)}>Beta</span>;

BetaPill.defaultProps = {
  className: null,
};

BetaPill.propTypes = {
  className: string,
};

export default BetaPill;
